import http from 'core/services/http';
import Config from 'core/config';
import axios from 'axios';

class SeatingChartService {
  static getRegSummaries(roomId) {
    return http.get(`${Config.apiUrl}/room/${roomId}/regsummaries`);
  }

  static assignRegs(locationEventId, data) {
    return http.put(`${Config.apiUrl}/locationevent/${locationEventId}/assignregs`, data);
  }

  static assignMaterialsToRegs(roomId, data) {
    return http.put(`${Config.apiUrl}/room/${roomId}/assignmaterialstoregs`, data);
  }

  static getStudentsList(roomId) {
    return http.get(`${Config.apiUrl}/query/registrations?roomId=${roomId}`);
  }
}

export default SeatingChartService;
